import React, { useState } from 'react';
import '../../styles/GroupProjectsContent.css';

function GroupProjectsContent() {
  const [selectedDateInfo, setSelectedDateInfo] = useState(null);
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' });

  const projectDates = {
    '2025-05-02': null,
    '2025-05-09': 'Hello students, please receive the group project on this link: google.docs.link',
    '2025-05-13': null,
    '2025-05-19': null,
    '2025-05-22': null,
  };

  const daysInMonth = new Date(2025, 4 + 1, 0).getDate();
  const firstDayOfMonth = new Date(2025, 4, 1).getDay();

  const getDayClass = (day) => {
    const dateKey = `2025-05-${day.toString().padStart(2, '0')}`;
    return projectDates[dateKey] ? 'project-day' : '';
  };

  const handleDayClick = (day) => {
    const dateKey = `2025-05-${day.toString().padStart(2, '0')}`;
    if (projectDates[dateKey]) {
      setSelectedDateInfo({ date: `0${day} May 2025`.slice(-11), message: projectDates[dateKey] });
    } else {
      setSelectedDateInfo(null);
    }
  };

  const closeInfoModal = () => {
    setSelectedDateInfo(null);
  };

  return (
    <div className="group-projects-content">
      <h2>Group Projects</h2>
      <div className="calendar">
        <div className="calendar-header">
          <h3>{currentMonth} 2025</h3>
        </div>
        <table className="calendar-table">
          <thead>
            <tr>
              <th>Sun</th><th>Mon</th><th>Tue</th><th>Wed</th><th>Thu</th><th>Fri</th><th>Sat</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {Array.from({ length: firstDayOfMonth }).map((_, index) => (
                <td key={`empty-${index}`} className="empty-cell"></td>
              ))}
              {Array.from({ length: daysInMonth }).map((_, dayIndex) => {
                const day = dayIndex + 1;
                const isProjectDay = getDayClass(day);
                return (
                  <td
                    key={day}
                    className={`${isProjectDay} ${currentDate.getDate() === day && currentDate.getMonth() === 4 && currentDate.getFullYear() === 2025 ? 'current-day' : ''}`}
                    onClick={() => handleDayClick(day)}
                  >
                    {day}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>

      {selectedDateInfo && (
        <div className="info-modal">
          <div className="modal-content">
            <span className="close-button" onClick={closeInfoModal}>&times;</span>
            <h3>{selectedDateInfo.date}</h3>
            <p>{selectedDateInfo.message}</p>
            {selectedDateInfo.message.includes('http') && (
              <p><a href={selectedDateInfo.message} target="_blank" rel="noopener noreferrer">Open Link</a></p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default GroupProjectsContent;